import React from "react";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import AdminPage from "./components/adminLogin/admin";
import ConnectPage from "./components/connect/connect";
import QuickConnectPage from "./components/QuickConnects/quickConnect";
import PhoneNumberPage from "./components/phoneNumber/displaynumber";
import HoursOperationPage from "./components/hoursOperation/displayhours";
import QueuesPage from "./components/queues/displayqueues";
import PromptsPage from "./components/prompts/promptsdisplay";
import RoutingPage from "./components/routingProfile/routedisplay";
import UserPage from "./components/users/userdisplay";
import Emergency from "./components/emergencyClose/emergency";
import Holiday from "./components/Holidaylist/holiday";
import Signuppage from "./components/signuppage/signup";
import PageNotFound from "./components/pageNotFound/PageNotFound";
import VoiceMail from "./components/VoiceMail/voiceMail";
import ProfilePage from "./components/SecurityProfiles/viewprofiles";
import AwsAccountsPage from "./components/AwsAccountsListPage/AwsAccountsListPage";
import InstanceListPage from "./components/AwsAccountsListPage/InstanceList";
const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/adminstrator-page" replace />,
  },
  {
      path: "/aws-AccountsList-page",
      element: <AwsAccountsPage />,
    },
    {
      path: "/instanceList-page",
      element: <InstanceListPage />,
  
    },
  {
    path: "/adminstrator-page",
    element: <AdminPage />,
  },
  {
    path:"/connect-page",
    element:<ConnectPage/>,
  },
  {
    path:"/emergency-page",
    element:<Emergency/>
  },
  {
    path:"/Holiday-page",
    elemnt:<Holiday/>
  },
  {
    path:"/VoiceMail-page",
    elemnt:<VoiceMail/>
  },
  {
     path:"/quickConnect",
     element: <QuickConnectPage/>,
    },
     {
      path: "/phonenumber-page",
      element: <PhoneNumberPage />,
    },
    {
      path: "/hoursoperation-page",
      element: <HoursOperationPage />,
    },
    {
      path:"/signup-page",
      element:<Signuppage/>

    },
    {
      path: "/queues-page",
      element: <QueuesPage />,
    },
    {
      path: "/prompts-page",
      element: <PromptsPage />,
    },
    {
      path: "/routing-page",
      element: <RoutingPage />,
    },
    {
      path: "/userConfigure-page",
      element: <UserPage />,
    },
    {
      path: "/securityProfiles",
      element: <ProfilePage />,
    },
    {
    path: "*",
    element: <PageNotFound />,
  },
]);

export default function Router() {
  return <RouterProvider router={router} />;
}
